import { createFileRoute } from '@tanstack/react-router';
import { EnterpriseBuilderView } from '@mews-commander/modules/src/modules/enterpriseBuilder';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Installation/EnterpriseBuilder/Index/')({
    beforeLoad: ({ context: { checkPlatformPrivilege } }) => {
        checkPlatformPrivilege('runInstallation');
    },
    component: EnterpriseBuilderView,
    staticData: {
        title: TextKey.EnterpriseBuilder,
        owner: MewsTeam.EcosystemExperience,
        type: RouteType.Frontend,
    },
});
